module.exports = __webpack_public_path__ + "static/media/tab-maintenance.3856c09f.svg";